var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import FileTypeFromMimeType from "core/helpers/file-type-from-mime-type";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import FileAttachment from "core/models/file-attachment";
let FileAttachmentsDescHelper = (_class = class FileAttachmentsDescHelper extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  compute([je]) {
    const helper = new FileTypeFromMimeType();
    const countPerType = je.fileAttachments.reduce((acc, curr) => {
      const type = helper.compute([curr.mimeType]);
      if (!type) return acc;
      if (!acc[type]) {
        acc[type] = 0;
      }
      acc[type] += 1;
      return acc;
    }, {});
    if (je.isFromHprim) {
      countPerType["HPRIM"] = je.apicryptMessageReceivedJournalEvents.length;
    }
    return this.counterToString(countPerType);
  }
  counterToString(countPerType) {
    let str = "";
    const keysArray = Object.keys(countPerType);
    keysArray.forEach((key, index) => {
      str += this.intl.t(`bioExamResultCodes.fileAttachments.${key}`, {
        count: countPerType[key]
      });
      if (index < keysArray.length - 1) {
        str += "<br />";
      }
    });
    return htmlSafe(str);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { FileAttachmentsDescHelper as default };